<div class="fnp-body">
    <router-outlet></router-outlet>
</div>